import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";

const SignUpRap = styled.div`
  height: 100vh;
  .all-sign-divs {
    display: flex;
    gap: 30px;
    padding: 15px;
    height: 100%;
  }
  .left-sign-div {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }
  .right-sign-div {
    width: 50%;
    border-radius: 15px;
  }

  .sign-1 p {
    color: #363d4f;
    font-weight: 400;
    font-size: 14px;
    max-width: 235px;
    text-align: center;
  }

  .sign-1 h2 {
    color: #060b13;
    font-weight: 600;
    font-size: 22px;
  }
  .sign-1 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }
  .sign-2,
  .sign-4 {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .sub-2-inner h4 {
    color: #060B13;
    font-weight: 500;
    font-size: 14px;

  }
  .sub-2-inner p {
    color: #818893;
    font-size: 12px;
    font-weight: 400;
    line-height: 15px;
    max-width: 181px;
  }
  .sub-2-inner {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .sign-2-sub-left {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .radio {
    border: 1px solid #828286;
    width: 14px;
    height: 14px;
  }
  .sign-2-sub {
    border: 0.8px solid #BAC0D499;
    width: 400px;
    padding: 30px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
  }
  .plug-icon {
    background: #ed1c24;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .email-sign input {
    border: 0.8px solid #bac0d4b2;
    width: 400px;
    height: 48px;

    border-radius: 100px;
    padding-left: 35px;
  }

  .email-sign {
    width: 400px;
    position: relative;
    display: flex;
    align-items: center;
  }

  .email-icon,
  .lock-icon {
    position: absolute;
    left: 10px;
  }

  .eye-icon {
    position: absolute;
    right: 10px;
    cursor: pointer;
  }
  .sign-3 label {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  /* Custom Checkbox Styling */
  .custom-checkbox {
    width: 16px;
    height: 16px;
    border-radius: 4px;

    display: inline-flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: none;
  }

  .custom-checkbox:checked::before {
    content: "✔";
    color: white;
    background: #ed1c24;
    width: 16px;
    height: 16px;
    border-radius: 4px;

    display: inline-flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: none;
  }
  .forget-link {
    color: #ed1c24;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
  }
  .sign-3 {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .login-btn {
    border-left: 2px;
    border-top: 2px;
    border-right: 5px;
    border-bottom: 5px;
    border-style: solid;
    background: #ed1c24;
    width: 400px;
    height: 55px;
    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-color: #060b13;
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
  }
  .login-btn:disabled {
  background: #fdb4b7; 
  cursor: not-allowed;
  opacity: 0.6;
}
  .line-div {
    width: 181px;
    height: 2px;
    background: #bac0d44d;
  }
  .all-line-div p {
    color: #475467;
    font-size: 12px;
    font-weight: 600;
  }
  .all-line-div {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .google-btn {
    color: #060b13;
    gap: 10px;
    background: #ffffff;
  }
  .have-account p {
    color: #475467;
    font-size: 14px;
    font-weight: 400;
  }
  .start-free-btn {
    color: #ed1c24;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
  }
  .have-account {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
  }
  .sign-5 p {
    color: #99a2af;
    font-size: 12px;
    font-weight: 400;
    max-width: 300px;
    text-align: center;
  }
  .sign-5 span {
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }
      @media (max-width: 992px) {
.right-sign-div {
  display: none;
}
.left-sign-div {
  width: 100%;
}
    }

     @media (max-width: 500px) {
.email-sign input,  .email-sign, .login-btn {
  width: 300px;
}
.login-btn {
  margin: auto;
}
     }
`;

const TextOverlay = styled.div`
  position: absolute;
  bottom: 0px;
  left: 23%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 24px;
  font-weight: bold;
  z-index: 2;
  max-width: 328px;
  .text-divs p {
    background: #ED1C24;
    padding: 5px 12px;
    border-radius: 100px;
    font-size: 11px;
    font-weight: 400px;
    width: 94px;
    margin-bottom: 10px;
  }
  .text-divs h6 {
    max-width: 220px;
    font-size: 12px;
    font-weight: 500;
    color: #F2F2F2;
    line-height: 26px;
  }
`;

const SliderContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 15px;
  background-size: cover;
  background-position: center;
  transition: background-image 1s ease-in-out;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #00000040;
    z-index: 1;
  }
`;

const Indicators = styled.div`
  position: absolute;
  bottom: 10px;
  left: 10%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
`;

const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${(props) => (props.active ? "#ffffff" : "#FFFFFF4D")};
  transition: background-color 0.3s;
   

`;

const images = [
  "/images/sign-1.png",
  "/images/sign-2.png",
  "/images/sign-3.png",
];

const PreSignUp = () => {
  const navigate = useNavigate()
  const [currentIndex, setCurrentIndex] = useState(0);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);

  const isValid =
    formData.email.trim() !== "" && formData.password.trim() !== "";

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  // Handle input changes
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleEmailMove = () => {
    navigate('/emailverification')
  }
  const handleMoveToSignUp = () => {
    navigate('/signUp')
  }
  return (
    <SignUpRap>
      <div className="all-sign-divs">
        <div className="left-sign-div">
          <div className="sign-1">
            <div className="plug-icon">
              <img src="/images/plu-icon.png" alt="" />
            </div>
            <h2>Choose account</h2>
            <p>Choose your account type
                 below to get started.</p>
          </div>
          <div className="sign-2">
           <div onClick={handleMoveToSignUp} className="sign-2-sub">
            <div className="sign-2-sub-left">
                <img src="/images/listener-person.png" alt="" />
                <div className="sub-2-inner">
                    <h4>Listener</h4>
                    <p>Join and explore a world of content 
                        curated just for you.</p>
                </div>
            </div>
            <input className="radio" type="radio" />
           </div>
           <div onClick={handleMoveToSignUp} className="sign-2-sub">
            <div className="sign-2-sub-left">
                <img src="/images/creator.png" alt="" />
                <div className="sub-2-inner">
                    <h4>Creator</h4>
                    <p>Unlock your potential and share your 
                        passion with the world.</p>
                </div>
            </div>
            <input className="radio" type="radio" />
           </div>
          </div>

         
          
        </div>

        {/* Image Slider */}
        <div className="right-sign-div">
          <SliderContainer
            style={{ backgroundImage: `url(${images[currentIndex]})` }}
          >
            <TextOverlay>
              <div className="text-divs">
                <p>For creator</p>
                <h6>Craft your content and 
                  establish your own guidelines.</h6>
              </div>
            </TextOverlay>

            <Indicators>
              {images.map((_, index) => (
                <Dot key={index} active={currentIndex === index} />
              ))}
            </Indicators>
          </SliderContainer>
        </div>
      </div>
    </SignUpRap>
  );
};

export default PreSignUp;
